import { api } from "@/api"

type RetrieveCategoryResponse = DeepReadonly<{
  id: string
  name: string
  parentCategoryId: string | null
  color: string | null
  path: string[]
  namePath: string
}>

export const retrieveCategory = async (
  categoryId: string
): Promise<RetrieveCategoryResponse> => {
  const response = await api.get<RetrieveCategoryResponse>(
    `/products/categories/${categoryId}`
  )
  return response.body
}
